export default __webpack_public_path__ + "static/media/react-logo.561f1671.png";